module.exports = __webpack_public_path__ + "img/sinisa.a7d99c17.jpg";